/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2026 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import { normalizeValueArrayToString } from '@/utils/general'
import { Box, Card, Heading } from '@chakra-ui/react'
import { useFetchItemsWithParamsV2 } from '@/hooks/fetch/useFetchItemsWithParamsV2'
import { getAIMetadataBySamId } from '@/services/sams'
import CircleLoader from '@/components/loaders/CircleLoader'
import { formLeosToZetons } from '@/utils/pds'

const AiMetadata = ({ samId }) => {
  const {
    itemsResponse,
    loading: isLoading
  } = useFetchItemsWithParamsV2({
    fetchService: getAIMetadataBySamId,
    fetchParams: { samId }
  })
  const Label = ({ children }) => <span className="mr-2 font-bold">{ children }</span>

  return (
    <Box maxWidth={{
      lg: '500px'
    }}>
      <h3 className="mb-3">
        {`AI Metadata (${itemsResponse?.data.length})`}
      </h3>
      { isLoading
        ? <CircleLoader />
        : itemsResponse?.data.map(ai => {
          return (
            <Card
              key={ai.id}
              as="article"
              className="p-5 mb-4 text-[13px]"
              variant="outline"
            >
              <Heading as="h2" size="sm" className="mb-2">
                Asset ID: { ai.aiMetadataAssetId}
              </Heading>
              <p><Label>AI Strategy:</Label> { ai.embeddingModel.name }</p>
              <p><Label>Description:</Label> { ai.embeddingModel.description }</p>
              <p><Label>Supported Files:</Label> { normalizeValueArrayToString(ai.embeddingModel.supportedFileTypes) }</p>
              <p><Label>Creation Cost:</Label> { formLeosToZetons(ai.processingCost, false) }</p>
            </Card>
          )
        })
    }
    </Box>
  )
}

export default AiMetadata
